import Vue from 'vue';
import VueRouter from 'vue-router';
import HomeView from '@/views/home/HomeView.vue';
import SecurityModule from '@/store/modules/SecurityModule';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/sessions/importées',
    name: 'session_imported',
    component: () => import(/* webpackChunkName: "session_imported" */ '@/views/sessions/SessionImportedView.vue'),
  },
  {
    path: '/sessions/import',
    name: 'session_import',
    component: () => import(/* webpackChunkName: "session_import" */ '@/views/sessions/SessionImportView.vue'),
  },
  {
    path: '/session/en-attente',
    name: 'session_pending',
    component: () =>
      import(/* webpackChunkName: "session_pending" */ '@/views/sessions/SessionPendingView.vue'),
  },
  {
    path: '/session/archivé',
    name: 'session_archived',
    component: () =>
      import(/* webpackChunkName: "session_archived" */ '@/views/sessions/SessionArchivedView.vue'),
  },
  {
    path: '/donnees/recherche',
    name: 'search',
    component: () =>
      import(/* webpackChunkName: "search" */ '@/views/data/SearchView.vue'),
  },
  {
    path: '/valorisation/interne',
    name: 'internal_valorisation',
    component: () =>
      import(/* webpackChunkName: "internal_valorisation" */ '@/views/valorization/InternalValorizationView.vue'),
  },
  // {
  //   path: 'session/affichage/:id',
  //   name: 'session_view',
  //   component: () =>
  //     import(/* webpackChunkName: "session_view" */ '@/views/SessionViewView.vue'),
  // },
  // {
  //   path: 'session/ajout',
  //   name: 'session_add',
  //   component: () =>
  //     import(/* webpackChunkName: "session_add" */ '@/views/SessionAddView.vue'),
  // },
  // {
  //   path: 'session/modification',
  //   name: 'session_edit',
  //   component: () =>
  //     import(/* webpackChunkName: "session_add" */ '@/views/SessionViewView.vue'),
  // },
  // {
  //   path: 'session/import',
  //   name: 'session_import',
  //   component: () =>
  //     import(/* webpackChunkName: "session_import" */ '@/views/SessionImportView.vue'),
  // },
  // {
  //   path: 'session/import_list',
  //   name: 'session_import_list',
  //   component: () =>
  //     import(/* webpackChunkName: "session_import" */ '@/views/SessionImportListView.vue'),
  // },
  // {
  //   path: '/mode',
  //   name: 'mode',
  //   component: () =>
  //     import(/* webpackChunkName: "data" */ '@/views/HomePageComponent.vue'),
  // },
  // {
  //   path: '/donnees',
  //   name: 'data',
  //   component: () =>
  //     import(/* webpackChunkName: "data" */ '@/views/HomePageComponent.vue'),
  // },
  // {
  //   path: '/donnees/requete',
  //   name: 'request',
  //   component: () =>
  //     import(/* webpackChunkName: "request" */ '@/views/HomePageComponent.vue'),
  // },
  // {
  //   path: '/donnees/preparation',
  //   name: 'preparation',
  //   component: () =>
  //     import(/* webpackChunkName: "preparation" */ '@/views/HomePageComponent.vue'),
  // },
  // {
  //   path: '/donnees/recuperation',
  //   name: 'recovery',
  //   component: () =>
  //     import(/* webpackChunkName: "recovery" */ '@/views/HomePageComponent.vue'),
  // },
  // {
  //   path: '/donnees/fiches-informatives',
  //   name: 'informative_sheets',
  //   component: () =>
  //     import(/* webpackChunkName: "informative_sheets" */ '@/views/HomePageComponent.vue'),
  // },
  // {
  //   path: '/donnees/import-externe',
  //   name: 'external_import',
  //   component: () =>
  //     import(/* webpackChunkName: "external_import" */ '@/views/HomePageComponent.vue'),
  // },
  // {
  //   path: '/valorisation',
  //   name: 'valorisation',
  //   component: () =>
  //     import(/* webpackChunkName: "valorisation" */ '@/views/HomePageComponent.vue'),
  // },
  // {
  //   path: '/valorisation/externe',
  //   name: 'external_valorisation',
  //   component: () =>
  //     import(/* webpackChunkName: "external_valorisation" */ '@/views/HomePageComponent.vue'),
  // },
  // {
  //   path: '/administration',
  //   name: 'administration',
  //   component: () =>
  //     import(/* webpackChunkName: "administration" */ '@/views/HomePageComponent.vue'),
  // },
  {
    path: '/administration/utilisateurs/affichage/:id',
    name: 'user_view',
    component: () =>
        import(/* webpackChunkName: "user_view" */ '@/views/administration/UserListView.vue'),
  },
  {
    path: '/administration/utilisateurs/edition/:id?',
    name: 'user_save',
    component: () =>
        import(/* webpackChunkName: "user_save" */ '@/views/administration/UserSaveView.vue'),
  },
  {
    path: '/administration/utilisateurs',
    name: 'user_list',
    component: () =>
      import(/* webpackChunkName: "user_list" */ '@/views/administration/UserListView.vue'),
  },
  {
    path: '/login',
    name: 'login',
    component: () =>
      import(/* webpackChunkName: "login" */ '@/views/security/LoginView.vue'),
  },
  {
    path: '/authentication',
    name: 'authentication',
    component: () =>
      import(/* webpackChunkName: "authentication" */ '@/views/security/AuthenticationView.vue'),
  },
  {
    path: '*',
    component: HomeView,
  },
];

const router = new VueRouter({
  mode: 'history',
  routes,
});

router.beforeEach((to, from, next) => {
  switch (true) {
    case !['login', 'authentication'].includes(to.name + '') && null === SecurityModule.token:
      next({ name: 'login' });
      break;

    case to.name === 'mode':
      next({ name: 'home' });
      break;
    // case to.name === "session_view":
    // case to.name === "session_edit":
    // case to.name === "session_add":
    //   next({ name: "session_list" });
    //   break;

    default:
      next();
      break;
  }
});

export default router;
